import React, { FC } from "react";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ArrowLeft: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faArrowLeft} {...props} />
);
